import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'
import React, { useCallback, useContext, useLayoutEffect, useRef } from 'react'
import { makeTextsHighlighted } from '../../../utils/SearchHelper'
import { Box, Text } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import PropTypes from 'prop-types'
import { scrollToReport } from '../../../utils/MenuHelper'
import { ReportContext } from '../../../contexts/ReportContext'

const SearchResultItem = observer(({ result, ...rest }) => {
  const {
    searchStore: { filteredCurrentResult, searchText },
  } = rootStore
  const { refScrollContainer } = useContext(ReportContext)
  const textRef = useRef(null)
  useLayoutEffect(() => {
    if (textRef.current && searchText !== '') {
      makeTextsHighlighted(textRef.current, searchText)
    }
  }, [filteredCurrentResult, searchText])

  const handleClick = useCallback(() => {
    if (result.chartId) {
      scrollToReport(result.chartId, refScrollContainer?.current)
    }
  }, [result, refScrollContainer])

  return (
    <Box
      onClick={handleClick}
      p="12px"
      backgroundColor="brand.lightGray"
      borderRadius="5px"
      m="4px 0"
      ref={textRef}
      cursor="pointer"
      {...rest}
    >
      <Text
        color="brand.textBlue"
        fontWeight="bold"
        mb="2px"
        textStyle="comments"
      >
        {result.path.map((title, index) => (
          <span key={index}>
            {title}
            {index < result.path.length - 1 && <ChevronRightIcon />}
          </span>
        ))}
      </Text>
      <Text textStyle="comments">{result.snippet?.join(', ')}</Text>
    </Box>
  )
})

SearchResultItem.propTypes = {
  result: PropTypes.shape({
    id: PropTypes.string,
    header: PropTypes.string,
    title: PropTypes.string,
    snippet: PropTypes.array,
    children: PropTypes.array,
    path: PropTypes.array,
  }),
  onClick: PropTypes.func,
}
export default SearchResultItem
